"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var MobileMenu = /** @class */ (function (_super) {
    __extends(MobileMenu, _super);
    function MobileMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobileMenu.prototype.render = function () {
        var _a = this.props, visible = _a.visible, toggleMobileNav = _a.toggleMobileNav;
        return (React.createElement("div", { className: "block lg:hidden h-full" },
            React.createElement("button", { onClick: function () { return toggleMobileNav(); }, className: "relative flex flex-wrap focus:outline-none items-center h-full pl-1-6 pr-1-6 " + (visible ? "bg-native" : "") },
                React.createElement("span", { className: "flex h items-center  transition pl-0-8 pr-0-8 " + (!visible ? "scale:0 opacity-0 invisible transition-delay-0" : "scale:1 opacity-100 visible") },
                    React.createElement(Snippets.Svg, { name: "cross", width: 14, className: "" })),
                React.createElement("span", { className: "absolute" },
                    React.createElement(Snippets.Svg, { name: "menu", width: 18, className: "block transition " + (!visible ? "scale:1 opacity-100 visible" : "scale:0 opacity-0 invisible transition-delay-0") }),
                    React.createElement("span", { className: "absolute text-xxxs uppercase font-extrabold flex w-full " + (visible ? "scale:0" : "") }, "Menu")))));
    };
    return MobileMenu;
}(React.PureComponent));
exports.MobileMenu = MobileMenu;
